//  共通JS
// document.write('<script type="text/javascript" src="/inc/js/page/magnific-popup.min.js"></script>');
// document.write('<script type="text/javascript" src="/inc/js/page/slick.min.js"></script>');
// document.write('<script type="text/javascript" src="/inc/js/page/matchHeight.min.js"></script>');
// document.write('<script type="text/javascript" src="/inc/js/page/scrollreveal.min.js"></script>');

jQuery(function($){
  var win = $(window);

//レスポンシブナビ
$("#menu-icon").on("click", function() {
  $('body').toggleClass('open');

  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $("#gnavi")
      .removeClass("open");
  } else {
    $(this).addClass("active");
    $("#gnavi")
      .addClass("open")
  }
});

$(".dropdownBtn").on("click", function() {
  $('.dropdownBtn').toggleClass('open');

  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(".dropdownBtn")
      .removeClass("open");
  } else {
    $(this).addClass("active");
    $(".dropdownBtn")
      .addClass("open")
  }
});


if(win.width() < 768) {
  $('.dropdownBtn').on('click', function(){
    $(this).toggleClass('open');
    $(this).next().slideToggle(200);
  });
}

// ページトップへ戻るのスクロール
var $pagetop = $('#pageTop');

if ($(window).width() > 768) $pagetop.hide();
$(window).scroll(function(){
  if($(window).scrollTop() > 200){
    $pagetop.fadeIn();
  } else {
    $pagetop.fadeOut();
  }
});

$pagetop.click(function(){
  $('html,body').animate({scrollTop:0},1000);
  return false;
});

// アンカーリンクを押すと、スクロール
$('a[href^=#]:not([class*="modal"])').click(function() {
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
});

//画像の遅延読み込み
if($('[class*="lazyload"]').length) {
  lazySizesConfig.loadMode = 1;
}


//ポップアップ
if($('[class*="popup"]').length) {
  // 通常のポップアップ
  $('.popup-image').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    fixedContentPos: true,
    mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
    image: {
      verticalFit: true
    },
    zoom: {
      enabled: true,
      duration: 300 // don't foget to change the duration also in CSS
    }
  });

  // ギャラリー
  $('.popup-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0,1] // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: function(item) {
        return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
      }
    }
  });

  // 動画
  $('.popup-movie').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
}

//スライドショー
if($('[class*="slider"]').length) {
  $('.mainSlider').slick({
    autoplay:true,
    dots:false,
		infinite: true,
    slidesToShow: 1,
    fade: true,
    speed:3000,
    arrows: false
  });
  $('.subSlider').slick({
    autoplay:true,
    dots:true,
		infinite: true,
    slidesToShow: 1,
    fade: true,
    speed:4000,
    arrows: false,
    dotsClass: 'slide-dots'
  });
}

//高さを揃える
  if($('.matchheight').length) {
    $('.matchheight').matchHeight();
  }

//アコーディオン
$('.accordion').each(function () {
  if ($(this).hasClass('active')) {
      var panel = $(this).next('.panel');
      $(this).next('.panel').css('max-height', panel[0].scrollHeight + "px");
  }
  $('.accordion').on('click', function () {
      $('.accordion').next('.panel').css('max-height', 0);
      $('.accordion').removeClass('active');
      panel = $(this).next('.panel');
      $(this).addClass('active');
      if (parseFloat($(this).next('.panel').css('max-height'))) {
          $(this).next('.panel').css('max-height', 0);
          $(this).removeClass('active');
      } else {
          $(this).next('.panel').css('max-height', panel[0].scrollHeight + "px");
      }
  });
});

// タブ
$('.tab-link').on('click', function () {
  $target = $(this).attr('data-tab');
  $mainParent = $(this).closest('.tabs');

  $mainParent.find('.tab-nav .tab-link').removeClass('active');
  $("[data-tab='" + $target + "']").addClass('active');

  $mainParent.find('.tab-content').removeClass('active');
  $('#' + $target).addClass('active');

});

$('.tab-close').on('click', function () {
  $(this).closest('.tab-content').removeClass('active');
});

//スクロール時のアニメーション

if($('.animate').length) {
  window.sr = ScrollReveal();
  sr.reveal('.animate', { easing: 'ease', duration: 2000, distance: '400px', opacity: 1, scale: 1 });
}


//スマホの時だけaタグが機能するように
var ua = navigator.userAgent.toLowerCase();
var isMobile = /iphone/.test(ua)||/android(.+)?mobile/.test(ua);

if (!isMobile) {
  $('a[href^="tel:"]').on('click', function(e) {
    e.preventDefault();
  });
}

//採用バナー
$(document).ready(function(){
  $("#Entry").hide();
  $(window).on("scroll", function() {
      if ($(this).scrollTop() > 200) {
          $('#Entry').fadeIn("fast");
      } else {
          $('#Entry').fadeOut("fast");
      }
    });
  });
  
});

